const state = {
  companyInfo:{},
  capacity:0,
  used:0,
  companyStructure:{}

}

const mutations = {
  setCompanyInfo(state,companyInfo){
    state.companyInfo = companyInfo
  },
  setCompanyStructure:function(state,list){
    state.companyStructure =  list
  },

  setCapacity(state,capacityData){
    state.capacity = capacityData.capacity
    state.used = capacityData.used
  },
}

const actions = {
  someAsyncTask ({ commit }) {
    // do something async
    commit('INCREMENT_MAIN_COUNTER')
  }
}

export default {
  state,
  mutations,
  actions
}
